module.exports = __webpack_public_path__ + "img/no-data.a35803fc.svg";